import(/* webpackMode: "eager", webpackExports: ["MinerTasks"] */ "/app/apps/web/app/dashboard/miner/[comp_id]/[hotkey]/_sections/MinerTasks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CopyButton"] */ "/app/apps/web/components/ui/CopyButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MineButton"] */ "/app/apps/web/components/ui/MineButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ContourCanvas"] */ "/app/packages/ui/src/ContourCanvas.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/NavDrawer.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/NavMenu.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/ThemeSwitch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useReducedMotion"] */ "/app/packages/ui/src/useReducedMotion.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useTheme"] */ "/app/packages/ui/src/useTheme.ts");
